<template>
  <div class="editOrgaBuild-coantainer">
    <base-dialog
      :model="editData.isOpen"
      title="分配组织"
      @close="handleClose"
    >
      <template #body>
         <el-form ref="lockForm" :model="formData" label-width="100px">
          <el-form-item label="组织" prop="orgaId">
            <el-select
                  v-model="formData.orgaId"
                  placeholder="请选择绑定组织">
                  <el-option
                    v-for="item in orgaInfoList"
                    :key="item.id"
                    :label="item.orgaName"
                    :value="item.id">
                  </el-option>
                </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template #footer>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="allocationOrganization">确 定</el-button>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import { getOrgaInfoListAll } from '@/api/orga'
import { bindLockOrga } from '@/api/lock'

export default {
  props: {
    editData: {
      type: Object
    }
  },
  data () {
    return {
      formData: {
        lockIdList: [],
        orgaId: ''
      },
      orgaInfoList: []
    }
  },
  watch: {
    'editData.isOpen': function (isOpen) {
      if (isOpen) {
        this.getOrgaInfoListAll()
         console.log('id:', this.editData.lockIdList)
        this.formData.orgaId = this.editData.orgaId
        this.formData.lockIdList = this.editData.lockIdList
      }
    }
  },
  methods: {
    /* 成功分配组织 */
    allocationOrganization () {
      this.$confirm('此操作重新分配组织, 是否确认?', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs.lockForm.validate((valid) => {
            console.log('valid', valid)
            if (valid) {
              console.log('data:', this.formData)
              bindLockOrga(this.formData).then(() => {
                  this.$message({
                  message: '分配成功',
                  type: 'success'
                  })
                  this.$emit('successHandle')
                  this.handleClose()
                })
              }
          })
        })
        .catch(() => {
          this.$message({
            type: 'warning',
            message: '已取消'
          })
        })
    },
    /* 获取全部组织 */
    getOrgaInfoListAll () {
      getOrgaInfoListAll().then(res => {
        this.orgaInfoList = res.data
      })
    },
    /* 关闭弹窗 */
    handleClose () {
      this.editData.isOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
